import SvgIcon from '@png/npm-svg-icon';

import jsonToView from '../api/json-to-view';
import ApiManager from '../api/manager';
import StockLocationAddToCart from './StoreLocationAddToCart';

class StockLocationFavorites {
  constructor() {
    this.config = {
      moduleList: () => document.querySelectorAll('[data-module="LocationFavoriteToggle"]'),
      favoriteList: () => document.querySelectorAll('[data-module="FavoriteLocations"]'),
      favoritesResult: el => el.querySelector('[data-child-module="FavoriteResults"]'),
      debounceTimeOut: 300,
      hasPreferenceObject: false,
      list: []
    };
    this.apiManager = new ApiManager();
  }

  // get user preference and return array of users locationFavorites
  getFavorites() {
    return this.apiManager
      .get('/api/v2/preference/user?key=locationFavorites')
      .then(response => {
        // return null if user preferences is empty
        if (!response.length) {
          return null;
        }

        if (!response[0].value) {
          return [];
        }
        // decode and parse data to json, then return
        return response[0].value.split(',');
      })
      .catch(e => {
        console.error(e);
      });
  }

  // update user preferences object in database with new data
  updateFavoritesList(array) {
    // debounce to prevent multiple API calls on spam click
    clearTimeout(this.config.debounce);
    this.config.debounce = window.setTimeout(() => {
      // convert array to encoded json string if not empty
      const json = array.length ? array.join(',') : '';

      // check if user is logged in, then run the process of the database update

      // if the hasPreferenceObject is false, create new user preference object in databsae. Otherwise update it with new value
      if (this.config.hasPreferenceObject) {
        const patchValue = JSON.parse(`[{"op":"replace","path":"/value","value":"${json}"}]`);
        this.apiManager
          .patch('/api/v2/preference/user/locationFavorites', patchValue)
          .then(response => response)
          .catch(e => {
            console.error(e);
          });
      } else {
        const postValue = JSON.parse(
          `{"key":"locationFavorites","value":"${json}","type":"string"}`
        );
        this.apiManager
          .post('/api/v2/preference/user', postValue)
          .then(response => response)
          .then(() => {
            this.config.hasPreferenceObject = true;
          })
          .catch(e => {
            console.error(e);
          });
      }
    }, this.config.debounceTimeOut);
  }

  handleModules() {
    const { moduleList } = this.config;

    moduleList().forEach(_module => {
      const module = _module;
      const { initialized, locationName } = module.dataset;

      if (initialized) return;

      module.dataset.initialized = true;

      module.addEventListener('click', async () => {
        const newList = [...this.config.list];

        if (newList.includes(locationName)) {
          const index = newList.indexOf(locationName);
          newList.splice(index, 1);
        } else {
          newList.push(locationName);
        }
        this.updateFavoritesList(newList);
        this.config.list = newList;
        this.renderToggles();
        this.remderFavoritesList();
      });
    });
  }

  renderToggles() {
    const { moduleList } = this.config;
    moduleList().forEach(_module => {
      const module = _module;
      const { locationName } = module.dataset;

      if (this.config.list.includes(locationName)) {
        module.classList.add('is-active');
      } else {
        module.classList.remove('is-active');
      }
    });
  }

  remderFavoritesList() {
    const { favoriteList, favoritesResult } = this.config;
    const { list } = this.config;

    favoriteList().forEach(async _module => {
      const module = _module;
      const {
        stockBranches,
        locations,
        productId,
        itemcode,
        description,
        orderUnit
      } = module.dataset;
      const newStockBranches = JSON.parse(stockBranches);

      const newLocations = JSON.parse(locations).filter(
        location =>
          list.includes(location.CompanyName) &&
          newStockBranches.some(x => x.Name === location.CompanyName)
      );

      if (list.length <= 0 || newLocations.length <= 0) {
        module.classList.add('hidden');
      } else {
        module.classList.remove('hidden');
        const html = await jsonToView(
          {
            locations: newLocations,
            stockBranches,
            productId,
            itemcode,
            productDescription: description,
            orderUnit
          },
          'FoundLocations'
        );
        favoritesResult(module).innerHTML = html;
        module.classList.remove('hidden');

        new SvgIcon().init();
        new StockLocationAddToCart().init();

        this.renderToggles();
        this.handleModules();
      }
    });
  }

  async init() {
    const response = await this.getFavorites();

    if (response != null) {
      this.config.hasPreferenceObject = true;
      this.config.list = response;
    }

    this.handleModules();
    this.renderToggles();
  }
}

export default StockLocationFavorites;
